import React, { useEffect, useState, useRef, useContext } from 'react'
import { useReactToPrint } from 'react-to-print';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import axios from 'axios';
import { Container } from '@mui/system';
import { TableContainer } from '@mui/material';
import Grid from '@mui/material/Grid';
import PrintIcon from '@mui/icons-material/Print';
import { ComponentToPrintShopReport } from './ComponentToPrintShopReport'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import LoaderDialog from './LoaderDialog';
import { AuthContext } from "../authContext/AuthContext";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const LineChart = ({startDate, endDate}) => {
  const [resData, setResData] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const componentRef= useRef();
  const handleReactToPrint = useReactToPrint({
    content: () => componentRef.current
  })
  const { user, shop } = useContext(AuthContext);

  useEffect(() => {
    const columns = [
      {"field": "id", "headerName": "#", "key":"aa"},
      {"field": "_id", "headerName": "Date"},
      {"field": "cash", "headerName": "Cash"},
      {"field": "cash_cancel", "headerName": "Cash Cancled"},
      {"field": "cash_with_cancel", "headerName": "Total Cash"},
      {"field": "card", "headerName": "Card"},
      {"field": "card_cancel", "headerName": "Card Cancled"},
      {"field": "card_with_cancel", "headerName": "Total Card"},
      {"field": "upi", "headerName": "UPI"},
      {"field": "upi_cancel", "headerName": "UPI Cancled"},
      {"field": "upi_with_cancel", "headerName": "Total UPI"},
      {"field": "total", "headerName": "Total"},
      {"field": "with_cancel", "headerName": "Cancel"},
      {"field": "gst0_spet", "headerName": "0% - Taxable Amt"},
      {"field": "gst0_cgst", "headerName": "0% - CGST"},
      {"field": "gst0_sgst", "headerName": "0% - SGST"},
      {"field": "gst5_spet", "headerName": "5% - Taxable Amt"},
      {"field": "gst5_cgst", "headerName": "5% - CGST"},
      {"field": "gst5_sgst", "headerName": "5% - SGST"},
      {"field": "gst12_spet", "headerName": "12% - Taxable Amt"},
      {"field": "gst12_cgst", "headerName": "12% - CGST"},
      {"field": "gst12_sgst", "headerName": "12% - SGST"},
      {"field": "gst18_spet", "headerName": "18% - Taxable Amt"},
      {"field": "gst18_cgst", "headerName": "18% - CGST"},
      {"field": "gst18_sgst", "headerName": "18% - SGST"},
      {"field": "roundoff", "headerName": "Round Off"},
      {"field": "without_cancel", "headerName": "Net"}]

    const loadData = async() => {
      try {
        setLoading(true)
        let d = new Date(endDate)
        d.setDate(d.getDate() + 1)
        const newEndDate = d.toISOString().split('T')[0]
        //const token = JSON.parse(localStorage.getItem("user")).token
        const res = await axios.post("/orders/date", {startDate, endDate: newEndDate}, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
        const sortedData = res.data.sort((a,b) => {return new Date(a._id).getTime() - new Date(b._id).getTime()});
        
        let sd = []
        await Promise.all(
          sortedData.map(async (item, index)=> {
            let printData = {...item, "_id": convertDate(item._id), "id": index + 1}
            let d = new Date(item._id)
            d.setDate(d.getDate() + 1)
            const newEndDate = d.toISOString().split('T')[0]
            const resGST = await axios.post("/orders/dateWithGST", {startDate: item._id, endDate: newEndDate}, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
            const gst0 = resGST.data.filter((gst) => gst._id === 0)[0];
            printData = {...printData, "gst0_spet" : gst0 ? parseFloat(gst0.spet).toFixed(2) : 0, "gst0_cgst" : gst0 ? gst0.cgst : 0, "gst0_sgst" : gst0 ? gst0.sgst : 0}
            const gst5 = resGST.data.filter((gst) => gst._id === 2.5)[0];
            printData = {...printData, "gst5_spet" : gst5? parseFloat(gst5.spet).toFixed(2) : 0, "gst5_cgst" : gst5 ? gst5.cgst : 0, "gst5_sgst" : gst5 ? gst5.sgst : 0}
            const gst12 = resGST.data.filter((gst) => gst._id === 6)[0];
            printData = {...printData, "gst12_spet" : gst12 ? parseFloat(gst12.spet).toFixed(2) : 0, "gst12_cgst" : gst12 ? gst12.cgst : 0, "gst12_sgst" : gst12 ? gst12.sgst : 0}
            const gst18 = resGST.data.filter((gst) => gst._id === 9)[0];
            printData = {...printData, "gst18_spet" : gst18 ? parseFloat(gst18.spet).toFixed(2) : 0, "gst18_cgst" : gst18 ? gst18.cgst : 0, "gst18_sgst" : gst18 ? gst18.sgst : 0}
            sd.push(printData)
          })
        );
        setResData(sd)
        if(sd) {
          setData({"rows": sd, "columns": columns})
        }
        setLoading(false)
      } catch (err) {
        console.log(err)
        setLoading(false)
      }
    }
    loadData();
  },[startDate, endDate, user, shop]);
  const convertDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.getDate() + "/" + (d.getMonth() + 1) + "/" +  d.getFullYear();
  }
  
  return (
    <Container maxWidth="false" disableGutters sx={{height: "85vh", width: "100vw"}}>
      <LoaderDialog open={loading} title="Loading Report Data ..."/>
      <Grid container>
        <Grid item xs={12} sx={{padding: 1}}>
        {resData && 
        <TableContainer>
          <PrintIcon size="small" onClick={handleReactToPrint} color="success"></PrintIcon>
        </TableContainer>}
        </Grid>
        {data && <DataGrid {...data} components={{ Toolbar: GridToolbar }}  componentsProps={{toolbar: {printOptions: { disableToolbarButton: true }}}} sx={{height: "80vh", width: "100vw"}}/>}
      </Grid>
      <div style={{display: 'none'}}>
        { resData && <ComponentToPrintShopReport ref={componentRef} title="Daily Sales Report" data={resData} /> }
      </div>
    </Container>
  )
}

export default LineChart
